import script from "./ReceitasPorRefil.vue?vue&type=script&setup=true&lang=js"
export * from "./ReceitasPorRefil.vue?vue&type=script&setup=true&lang=js"

import "./ReceitasPorRefil.vue?vue&type=style&index=0&id=07c36042&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07c36042"]])

export default __exports__